export default function SocialProofBar() {
  return (
    <div className="bg-navy py-5">
      <div className="section-container">
        <p className="font-body text-sm text-white text-center">
          Join{' '}
          <span className="font-semibold text-gold">hundreds</span>
          {' '}of people who never want to miss a moment again.
        </p>
      </div>
    </div>
  );
}
